import { cva } from '@/styled-system/css';

export const drawerBackdropRecipe = cva({
  base: {
    blockSize: '100%',
    display: 'grid',
    inlineSize: '100%',
    maxBlockSize: '100%',
    maxInlineSize: '100%',
    placeItems: 'center',
    zIndex: 'modal',

    _before: {
      content: '""',
      position: 'fixed',
      inset: 0,
      backgroundColor: 'bg.screen.scrim',
      zIndex: 1,
      transitionProperty: {
        _motionReduce: 'none',
        _motionSafe: 'opacity',
      },
      transitionDuration: {
        _motionReduce: '0s',
        _motionSafe: '{durations.250}',
      },
      transitionTimingFunction: '{easings.ease-out}',
    },
  },
  variants: {
    open: {
      true: {
        _before: {
          opacity: 'dialogScrim',
        },
      },
      false: {
        _before: {
          opacity: 0,
        },
      },
    },
    placement: {
      bottom: {
        paddingBlockStart: 'layout.looser',
      },
      left: {
        paddingInlineEnd: 'layout.looser',
      },
      right: {
        paddingInlineStart: 'layout.looser',
      },
    },
    scrim: {
      false: {
        _before: {
          display: 'none',
        },
      },
    },
    contained: {
      true: {
        _before: {
          position: 'absolute',
        },
      },
    },
  },
});
